import http from "@/apis/http";
import url from "@/config/url";

const activity = url.activity;

export default {
  board: {
    getData: (params) => http.post(activity.board.search, params),
    getColumns: (params) => http.post(activity.board.columns, params),
  },
  agent: {
    getData: (params) => http.post(activity.agent.search, params),
    getColumns: (params) => http.post(activity.agent.columns, params),
  },
  detail: {
    getData: (params) => http.post(activity.detail.search, params),
    getColumns: (params) => http.post(activity.detail.columns, params),
  },
  member_search: {
    getData: (params) => http.post(activity.member_search.search, params),
    getColumns: (params) => http.post(activity.member_search.columns, params),
  },
};
